<template>
  <div class="mt-5 mx-10 mb-10">
    <TimeFrameButtons
      :title="'My Recent Tasks'"
      :time-frames="['In-Progress', 'Overdue', 'Pending']"
      :active-time-frame="activePeriod"
      @change-time-frame="changeTimeFrame"
    />
    <v-row v-if="tasks.length >= 1" class="mt-2" >
      <v-col v-for="(task, index) in tasks" :key="index" cols="12" xs="12" md="4" class="h-100">
        <div class="project-box">
          <TaskCard :task="task" />
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-alert type="info" text="" variant="tonal" color="red">No Recent Tasks Available.</v-alert>
      </v-col>
    </v-row>
    <v-row class="mx-1 my-5 d-flex flex-row justify-end">
      <v-btn  v-if="tasks.length >= 6" elevated  class="white--text" color="#00B3FF" title="Add" :to="'/tasks'" rounded>
        View all Tasks
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import TaskCard from '@/components/dashboard/TaskCard.vue';
import TimeFrameButtons from '@/components/dashboard/TimeFrameButtons.vue';
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { TaskService } from "@/services/task-service.js";

export default {
  components: {
    TaskCard,
    TimeFrameButtons
  },
  data() {
    return {
      activePeriod: 'In-Progress',
      tasks: [],
      loading: false,
      filter: 'In-Progress'
    };
  },
  mounted() {
    this.changeTimeFrame(this.activePeriod);
  },
  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },
  methods: {
    changeTimeFrame(timeFrame) {
      this.activePeriod = timeFrame;
      this.filter = timeFrame;
      this.getAuthUserRecentTasks();
    },

    getAuthUserRecentTasks() {
      this.loading = true;
      TaskService.getAuthUserRecentTasks(this.filter)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.tasks = response.data.data;
          }
        })
        .catch(error => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    isActive(timeFrame) {
      return this.activePeriod === timeFrame;
    },
  },
};
</script>
